import LegalLayout from "../components/LegalLayout";
import Markdown from "../components/Markdown";
import { useContent } from "../context/ContentContext";
import { DEFAULT_DATENSCHUTZ } from "../lib/legalDefaults";

export default function Datenschutz() {
  const { content } = useContent();
  const legal = content?.legal || {};
  const text = legal.datenschutz?.body || DEFAULT_DATENSCHUTZ;
  const updated = legal.datenschutz?.updated || "Mai 2026";
  return (
    <LegalLayout eyebrow="Legal · 02" title="Datenschutz" updated={updated}>
      <Markdown source={text} />
    </LegalLayout>
  );
}
